import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as pbi from 'powerbi-client';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-report-embed',
  templateUrl: './report-embed.component.html',
  styleUrls: ['./report-embed.component.scss']
})
export class ReportEmbedComponent implements OnInit {
  private reportId;
  bac: string;
  numericBAC: number;
  dealerName: string;
  private powerbi: pbi.service.Service;

  constructor(private reportService: ReportsService, private route: ActivatedRoute) {
    this.powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory)
  }

  ngOnInit(): void {
    this.reportId = this.route.snapshot.paramMap.get('id');
    this.bac = this.route.snapshot.paramMap.get('bac');
    this.numericBAC = +this.bac;

    this.route.queryParams.subscribe(params => {
      this.dealerName = params['dealer'];
    });

    var embedToken;
    this.reportService.getEmbedToken(this.reportId, this.bac).subscribe(data => {
      embedToken = data.token;

      var embedConfiguration = {
        type: 'report',
        id: this.reportId,
        embedUrl: 'https://app.powerbi.com/reportEmbed',
        tokenType: pbi.models.TokenType.Embed,
        accessToken: embedToken
      };

      var reportContainer = <HTMLElement>document.getElementById('reportContainer');
      var report = this.powerbi.embed(reportContainer, embedConfiguration);
      

      report.off("loaded");

      report.on("loaded", function () {
      });
    })

  }

}
